import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';
import { withRouter } from 'react-router';
import classNames from 'classnames';
import { Header, Modal, OrderSoundPlayer, OrderSoundNotification } from '@chama/ui-components';
import { intlPropTypes, routerPropTypes } from '@chama/utils';
import PageSidebar from '../PageSidebar';
import './index.css';

const propTypes = {
  ...intlPropTypes,
  ...routerPropTypes,
  logout: PropTypes.func.isRequired,
  isSoundEnabled: PropTypes.bool.isRequired,
  soundIntervalOfFive: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  muteSound: PropTypes.func.isRequired,
  unmuteSound: PropTypes.func.isRequired,
  isSoundMuted: PropTypes.bool.isRequired,
  subheader: PropTypes.func,
  children: PropTypes.node,
  hasUserInteractedWithPage: PropTypes.bool.isRequired,
  withOldHeader: PropTypes.bool,
  withFullWidth: PropTypes.bool,
  withSidebar: PropTypes.bool,
};

const defaultProps = {
  subheader: null,
  children: null,
  withOldHeader: true,
  withFullWidth: false,
  withSidebar: true,
};

class PageContainerLayout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSidebarExpanded: false,
    };
  }

  showLogouModal = () => {
    this.modal.show();
  };

  handleRef = refName => {
    return ref => {
      this[refName] = ref;
    };
  };

  expandSidebar = () => {
    this.setState({
      isSidebarExpanded: true,
    });
  };

  retractSidebar = () => {
    this.setState({
      isSidebarExpanded: false,
    });
  };

  handleLogout = () => {
    this.props.router.push('/logout');
  };

  onSoundClick = () => {
    const { isSoundMuted } = this.props;

    if (isSoundMuted) {
      this.props.unmuteSound();
    } else {
      this.props.muteSound();
    }
  };

  render() {
    const {
      logout,
      isSoundEnabled,
      soundIntervalOfFive,
      subheader,
      children,
      name,
      title,
      isSoundMuted,
      intl: { formatMessage },
      routes,
      soundWarningDismissed,
      soundFailed,
      soundPlayed,
      hasUserInteractedWithPage,
      router,
      location,
      withOldHeader,
      withFullWidth,
      withSidebar,
    } = this.props;
    const { isSidebarExpanded } = this.state;
    const pageContainerClass = classNames('PageContainer', {
      'is-sidebar_expanded': isSidebarExpanded,
    });
    const currentRoute = routes[routes.length - 1];

    return (
      <div className={pageContainerClass}>
        <div className="PageContainer__content">
          {withSidebar && (
            <PageSidebar
              onExpandSidebar={this.expandSidebar}
              onRetractSidebar={this.retractSidebar}
              isSidebarExpanded={isSidebarExpanded}
              username={name}
              onLogout={this.handleLogout}
              isSoundMuted={isSoundMuted}
              onSoundClick={this.onSoundClick}
              formatMessage={formatMessage}
              currentPath={location.pathname}
            />
          )}

          <div
            className={classNames('PageContainer__main_wrapper', {
              'PageContainer__main_wrapper--without-sidebar': !withSidebar,
            })}
          >
            {withOldHeader && (
              <Header
                isDark
                subheader={subheader}
                title={title || (currentRoute && currentRoute.title)}
              />
            )}
            <main className={classNames({ u__container: !withFullWidth })}>{children}</main>
          </div>
        </div>

        <Modal
          onConfirm={logout}
          ref={this.handleRef('modal')}
          size="x-small"
          title={formatMessage({
            id: 'logout_confirm_sure',
            defaultMessage: 'Are you sure you want to sign out?',
          })}
          cancelButtonText={formatMessage({
            id: 'logout_confirm_cancel',
            defaultMessage: 'No',
          })}
          confirmButtonText={formatMessage({
            id: 'logout_confirm_logout',
            defaultMessage: 'Sign out',
          })}
        >
          <FormattedMessage
            id="logout_confirm_description"
            defaultMessage="You will continue to appear opened or closed according to the opening and closing times"
          />
        </Modal>
        {!hasUserInteractedWithPage && (
          <OrderSoundNotification
            hasUserInteractedWithPage={hasUserInteractedWithPage}
            onSoundWarningDismissed={soundWarningDismissed}
          />
        )}
        <OrderSoundPlayer
          loopInterval={soundIntervalOfFive ? 5000 : 1000}
          isSoundEnabled={isSoundEnabled}
          onSoundFailed={soundFailed}
          onSoundPlayed={soundPlayed}
        />
      </div>
    );
  }
}

PageContainerLayout.propTypes = propTypes;
PageContainerLayout.defaultProps = defaultProps;

const componentWithRouter = withRouter(PageContainerLayout);
const componentWithIntl = injectIntl(componentWithRouter);

export default componentWithIntl;



// WEBPACK FOOTER //
// ./src/components/PageContainerLayout/index.jsx